import { ScientificNumber } from '@cash-web/protos/squareup/cash/plasma/common/ScientificNumber.pb'

export const roundToTwoDecimals = (value: number): number => {
  return Math.round((value + Number.EPSILON) * 100) / 100
}

export const scientificNumberToFloat = ({ significand, magnitude }: ScientificNumber = {}): number | undefined => {
  if (significand === undefined || magnitude === undefined)
    throw new Error('The significand and magnitude must be defined')

  const withMagnitude = roundToTwoDecimals(10 ** magnitude)
  const result = roundToTwoDecimals(significand * withMagnitude)
  return result
}

export const numberToScientificNumber = (percentageAmount: number): ScientificNumber => {
  if (typeof percentageAmount !== 'number') throw new Error('The percentage amount must be a number')

  // this is set to ensure the significand is always a whole number
  const magnitude = -2
  const significand = percentageAmount / 10 ** magnitude

  return { significand, magnitude }
}
